/** Loads stripe.js once. Shared by the Payment Element (StripePayment) and the wallet express (StripeExpress). */
export function loadStripeJs() {
    if (window.Stripe) return Promise.resolve();
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://js.stripe.com/v3/';
        script.onload = resolve;
        script.onerror = () => reject(new Error('stripe.js'));
        document.head.appendChild(script);
    });
}
